import * as React from 'react';
import { Feature } from '@tencent/workbench';
import type { IShowCommentAnchorFeature } from './show-comment-anchor-interface';
import { config } from './config';
import { CheckboxWithLabel } from '@src/framework/workbench/common/components/checkbox-component';
import { BaseCheckFeature } from '@src/framework/workbench/common/feature/base-check-feature';
import { EventCodeType, TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';

@Feature()
export class ShowCommentAnchorFeature extends BaseCheckFeature implements IShowCommentAnchorFeature {
    public id = config.id;
    public config = config;

    public getContent = () => <CheckboxWithLabel
        label={config.content}
        checked={this.buttonChecked}
        onChange={this.updateDisplay}
    />;

    protected isDisplayed(): boolean {
        const commentManager = this.getAppService().viewableServiceLayer.commentManager.dangerousInstance;
        return !!commentManager?.isCommentAnchorShown;
    }

    protected loadAsync(): Promise<any> {
        return this.getAppService().viewableServiceLayer.commentManager.promise();
    }

    private updateDisplay = () => {
        this.getAppService().viewableServiceLayer.commentManager.promise().then((commentManager) => {
            const isCommentAnchorShown = !commentManager.isCommentAnchorShown;
            commentManager.setIsCommentAnchorShown(isCommentAnchorShown);
            this.report(
                TDWActionType.SHOW_COMMENTS_MARKS, EventCodeType.DOC_PPT_REVIEW_TAB_SHOW_COMMENTS_MARKS,
                isCommentAnchorShown,
            );
        });
    };

    private report(action: string, eventcode: string, show: boolean) {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.TOOLBAR_REVIEW_TAB,
            ver3: 1,    // menu
            ver5: show ? 1 : 0,
            action,
            eventcode,
        });
    }
}
